<template>
    <swiper-slide>
        
        <div class="d-flex align-center">
            <div class="upcoming-events-date">
                <p class="upcoming-events-month">{{ month }}</p>
                <p class="upcoming-events-day">{{ day }}</p>
            </div>
            <div class="upcoming-events-slider-slide-text">
                {{ text }}
            </div>
        </div>
    </swiper-slide>
</template>
<script>
export default {
    name: 'UpcomingEventsSliderSlide',
    props: {
        date:String,
        text:String
    },
    computed: {
        month() {
            let month = this.date.split('.')[1]
            let monthDict = {
                '0': 'янв',
                '1': 'фев',
                '2': 'март',
                '3': 'апр',
                '4': 'май',
                '5': 'июн',
                '6': 'июл',
                '7': 'авг',
                '8': 'сен',
                '9': 'окт',
                '10': 'ноя',
                '11': 'дек',
            }
            if (Object.keys(monthDict).includes(month))
                return monthDict[month]
            return ''
        },
        day() {
            return this.date.split('.')[0]
        }
    }
}
</script>